/**
 * Section Rendez-vous — Stub pour V1.
 *
 * Affiche la date de visite en lecture seule.
 * La planification complète (calendrier + confirmation client) arrivera en vague 3.
 */
export default function SectionRendezVous({ data }) {
  const dateVisite = data?.date_visite;
  const formatted = dateVisite
    ? new Date(dateVisite).toLocaleDateString('fr-FR')
    : null;

  return (
    <div className="space-y-4">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-3 text-sm text-yellow-800">
        Planification complète (calendrier + confirmation client) à venir.
        Pour l'instant, renseignez la date de visite dans la section Mission.
      </div>

      <div className="bg-white border border-slate-200 rounded-lg px-4 py-3">
        <div className="text-xs text-slate-500 uppercase tracking-wide mb-1">
          Date de visite
        </div>
        <div className="text-base font-medium">
          {formatted ?? (
            <span className="text-slate-400 italic">
              Visite pas encore planifiée
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
